import React, { useState } from "react";
import axios from "../../utils/axios";
import { notifyError, notifySuccess } from "../../utils/toastError";

const style = {
  numberItemDiv:
    "px-3 py-1 bg-gray-900 border-2 border-lyellow font-bold text-lyellow rounded",
  numberItemInput:
    "outline-none bg-transparent w-[25em] h-8 text-sm text-center",
  starItem: "text-[#FFD700] text-3xl relative z-50 left-[2.5em] bottom-4",
  buttonStyle:
    "bg-lyellow text-md font-semibold py-3 px-[5em] hover:bg-[#1d2226] hover:text-white transition ease-in duration-50 rounded-lg",
};

const MarketingModal = ({ setShowModal, showModal }) => {
  const [marketing, setMarketing] = useState({
    title: "",
    walletaddress: "",
  });

  const handleChangeNumber = (e) => {
    e.preventDefault();
    setMarketing({ ...marketing, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { title, walletaddress } = marketing;
    if (title === "" || walletaddress === "") {
        notifyError("Please fill all the fields");
        }
    else {
        try{
          const response = await axios.post(`api/marketing/addmarketing`,{userhandle:title, walletaddress},
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
                "Access-Control-Allow-Headers":
                  "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              },
            }
          ); 
          const data = response.data;
          if (data.success) {
            notifySuccess("Successfully added");
            marketing.title = "";
            marketing.walletaddress = "";
            setShowModal(false);
          } else {
            notifyError(data.message);
          }
        }
        catch(err){
            notifyError("User Already Exists. No Need to Add Again");
        }
        

        // if (data.success) {
        //     notifySuccess("Successfully added");
        //     setShowModal(false);
        // }
        // else {
        //   console.log(data.message);
        //   notifyError("Error adding");
        //   setShowModal(false);
        // }

        // marketing.title = "";
        // marketing.walletaddress = "";
    }

  };

  return (
    <>
    {showModal && (
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black/60">
    <div className=" flex justify-center items-center w-full">
      <div className="flex mt-6 mb-10 mx-auto w-[35em] rounded-xl">
        {/*content*/}
        <div className="border rounded-lg shadow-lg relative flex flex-col w-full bg-black border-lyellow/40">
          {/*header*/}
          <div className="flex items-center justify-between p-5 border-b border-solid border-lyellow rounded-t text-lyellow">
            <h3 className="text-2xl font-semibold tracking-wide">
              Enter Details for Giveaway
            </h3>
            <button
              className="text-lyellow font-extrabold text-xl"
              onClick={() => setShowModal(false)}
            >
              X
            </button>
          </div>
          {/*body*/}
          <div className="relative p-6 flex-auto text-lyellow flex items-center justify-center flex-col">
            <div className="flex items-center flex-col gap-y-5">
              <div className="flex items-center flex-col">
                <label
                  htmlFor="title"
                  className="text-xl font-semibold tracking-wider cursor-pointer"
                >
                  Twitter UserName
                </label>
              </div>
              <div className="flex">
                <div className={style.numberItemDiv}>
                  <input
                    id="title"
                    type="text"
                    className={style.numberItemInput}
                    name="title"
                    value={marketing.title}
                    onChange={handleChangeNumber}
                    placeholder="mad_Technologies"
                  />
                </div>
              </div>
            </div>
          

            <div className="flex items-center flex-col gap-y-5">
              <div className="flex items-center flex-col mt-5">
                <label
                  htmlFor="walletaddress"
                  className="text-xl font-semibold tracking-wider cursor-pointer"
                >
                  Wallet Address
                </label>
                <p className="text-red-500 text-sm">*Where the winning amount will be sent</p>
              </div>
              <div className="flex">
                <div className={style.numberItemDiv}>
                  <input
                    className={style.numberItemInput}
                    name="walletaddress"
                    id="walletaddress"
                    type="walletaddress"
                    placeholder="0xCX516561X8BcX4a33Ee62Xd105c"
                    value={marketing.email}
                    onChange={handleChangeNumber}
                  />
                </div>
              </div>
              <div>
                <p className="text-sm text-red-500">*You only need to provide details once but can share multiple times</p>
              </div>
            </div>
          </div>
          {/*footer*/}
          <div className="flex flex-col items-center justify-center p-6 border-t border-solid border-lyellow rounded-b text-black gap-y-5">
            <button
              className={style.buttonStyle.concat(" px-[5.7em]")}
              onClick={handleSubmit}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
    )}
    </>
);
}

export default MarketingModal